
export default function homeworkStyles () {
  return {
    "&.MuiPaper-root": {
      display: 'flex',
      padding: 30,
      color: '#606674',
      flexGrow: 1,
     '& .break': {
        flexBasis: '100%',
        height: 0
      },
      "& .flexWrap": {
        flexWrap: 'wrap'
      },
      "& .comments": {
        marginTop: 20,
        '&.hide': {
          display: 'none'
        }
      },
      "hr": {
        borderTop: 'none',
        borderBottom: '1px solid #ddd'
      },
      "& .wrapper": {
        overflowY: 'auto',
        padding: '0 10px',
        flexGrow: 1,
        display: 'flex'
      },
      "& .root": {
        color: '#4f576e',
        flexGrow: 1,
      },
      "& .content": {
        flexGrow: 1,
        overflowY: 'auto',
        '& .container': {
          padding: 65
        }
      },
      "& .leftColumn": {
        display: 'flex',
        flexDirection: 'column',      
        flexGrow:1,
        marginRight: '5%'
      },
      "& .rightColumn": {
        display: 'flex',
        flexGrow:1,
        flexDirection: 'column',
        marginRight: '5%'
      },
      "& .titleText": {
        textTransform: 'capitalize',
        fontWeight: 'bold',
        position: 'absolute',
        color: '#4e576e',
        marginTop: 10    
      },
      "& .title": {
        borderBottom: '1px solid #ccc',       
        clear: 'both',
        marginBottom: 10,
      },
      "& .titleActions": {
        float: 'right'
      },
      "& .field": {
        marginBottom: 25,
        '& > label': {
          display: 'block',
          fontWeight: 'bold',
          marginBottom: 10,
          marginRight: 50
        },
        '& > span': {
          display: 'block',
          marginBottom: 20               
        },
        '& .score': {
          minWidth: 80,
          width: 80
        },
        '& > span.status': {
          textTransform: 'capitalize',
          padding: '5px',
          color: '#fff',
          borderRadius: '20px',
          display: 'inline-block',
          width: 100,
          textAlign: 'center',
          '&.assigned': {
            backgroundColor: '#f78d43'
          },
          '&.completed': {
            backgroundColor: '#06b71c'
          },
          '&.pending': {
            backgroundColor: '#0ac7ff'
          },
          '&.returned': {
            backgroundColor: '#ff0a0a'
          }
        },
        '&.hide': {
          display: 'none'
        }
      },
      "& .dates": {
        display: 'flex',
        flexWrap: 'wrap',
        '& label': {
          minWidth: 100
        },
        '& span': {        
          '& svg': {
            position: 'relative',
            marginTop: '-10px',
            color: '#639de2',
            top: 7
          }        
        }
      },
      "& .resources": {
        marginBottom: 15,
        '& > label': {
          display: 'block',
          fontWeight: 'bold',
          minWidth: 420,
          marginBottom: 10
        },
        '& div': {
          minHeight: 30
        },
        '& a': {
          textDecoration: 'none',
          color: '#009dd8',
          '&:hover': {
            textDecoration: 'underline'
          }
        },
        '& svg': {
          position: 'relative',
          marginTop: '-10px',
          color: '#10b1b2',
          top: 5,
          height: 20
        }  
      }, 
      "& .feedback": {
        textAlign: 'center',
        paddingRight: 30
      },
      "& .myfiles": {
        '& > label': {
          display: 'block',
          fontWeight: 'bold',
          minWidth: 420,
          marginBottom: 10
        },
        '& .myfiles-container': {
          textAlign: 'left'
        },
      }
    }
  }
}
